// Typed access to Vite environment variables
// VITE_BUILD_ID: set by CI to the GitHub Actions run ID (e.g. "12345678")
// VITE_GIT_SHA:  set by CI to the short commit SHA (e.g. "a1b2c3d")
// VITE_ENVIRONMENT: 'stage' | 'prod' (set in SWA application settings per environment)

export const env = {
  appInsightsConnectionString: import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING ?? '',
  sentryDsn: import.meta.env.VITE_SENTRY_DSN ?? '',
  buildId: import.meta.env.VITE_BUILD_ID ?? 'local',
  gitSha: import.meta.env.VITE_GIT_SHA ?? 'local',
  environment: (import.meta.env.VITE_ENVIRONMENT ?? 'local') as 'local' | 'stage' | 'prod',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
  isStage: import.meta.env.VITE_ENVIRONMENT === 'stage',
  isProd: import.meta.env.VITE_ENVIRONMENT === 'prod',
}

const rawVersion = import.meta.env.VITE_APP_VERSION ?? 'dev'
const appVersion = rawVersion.replace('release/', '')

export const buildVersion = env.gitSha !== 'local'
  ? `${appVersion} (${env.gitSha.slice(0, 7)})`
  : 'kehitys'
